import { ca } from '@cian/analytics';
import { IPromoProduct } from '../../../types/product';

interface ITrackLinkClickParams {
  isBlackFriday: boolean;
  product: IPromoProduct;
  type: 'to_offers' | 'to_jk' | 'to_listingjk';
}

export const trackLinkClick = (params: ITrackLinkClickParams) => {
  if (params.isBlackFriday) {
    trackBlackFridayLinkClick(params);
  } else {
    trackStandardLinkClick(params);
  }
};

function trackStandardLinkClick({ product, type }: ITrackLinkClickParams) {
  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    name: 'oldevent',
    label: type,
    products: [product],
  });
}

function trackBlackFridayLinkClick({ product, type }: ITrackLinkClickParams) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'BlackFriday',
    name: 'oldevent',
    label: 'co_promos_modal',
    products: [product],
    page: {
      extra: {
        type,
      },
    },
  });
}
